/**
 * Меншены. В тексте хранится стабильный `[[<node-id>]]` — id, не заголовок,
 * поэтому переименование цели ссылку не ломает (data-model §2.3).
 *
 * Текст — источник правды; ребро `mention` производно. Тот же парсер гоняет клиент,
 * чтобы бэклинки обновились сразу после правки строки, до подтверждения сервером
 * (ui-spec 8.6) — иначе две реализации разъедутся.
 */

const MENTION_RE = /\[\[([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\]\]/gi;

/** Все id, упомянутые в тексте, без повторов и в порядке появления. */
export function parseMentions(text: string | null | undefined): string[] {
	if (!text) {
		return [];
	}
	const found: string[] = [];
	const seen = new Set<string>();
	for (const m of text.matchAll(MENTION_RE)) {
		const id = m[1]!.toLowerCase();
		if (!seen.has(id)) {
			seen.add(id);
			found.push(id);
		}
	}
	return found;
}

/**
 * Меншены ноды — объединение `title` и `body`.
 * Считать по одному полю нельзя: правка `title` снесла бы ребро, живущее в `body`
 * (service-layer §5.5).
 */
export function mentionsOf(node: { title: string; body: string | null }): string[] {
	const seen = new Set<string>();
	const out: string[] = [];
	for (const id of [...parseMentions(node.title), ...parseMentions(node.body)]) {
		if (!seen.has(id)) {
			seen.add(id);
			out.push(id);
		}
	}
	return out;
}

export function formatMention(nodeId: string): string {
	return `[[${nodeId}]]`;
}
